// Launch Mode: Visual Studio is intentionally disabled for launch stability
// and will be re-enabled after API reliability testing.
// To re-enable: set NEXT_PUBLIC_VISUAL_STUDIO_ENABLED=true in .env

export const VISUAL_STUDIO_ENABLED =
  process.env.NEXT_PUBLIC_VISUAL_STUDIO_ENABLED === 'true';

/**
 * Categorizes an API error for admin/test mode diagnostic logging.
 * Normal users never see these raw messages.
 */
export function categorizeImageError(err: unknown): {
  category: 'api_key_missing' | 'openai_error' | 'prompt_validation' | 'network_failure' | 'credit_failure' | 'unknown';
  detail: string;
} {
  const msg = err instanceof Error ? err.message : String(err ?? '');
  const lower = msg.toLowerCase();

  if (lower.includes('api key') || lower.includes('401') || lower.includes('authentication') || lower.includes('unauthorized')) {
    return { category: 'api_key_missing', detail: msg };
  }
  if (lower.includes('400') || lower.includes('invalid') || lower.includes('validation') || lower.includes('prompt')) {
    return { category: 'prompt_validation', detail: msg };
  }
  if (lower.includes('credit') || lower.includes('quota') || lower.includes('billing')) {
    return { category: 'credit_failure', detail: msg };
  }
  if (lower.includes('network') || lower.includes('fetch') || lower.includes('econnrefused') || lower.includes('timeout')) {
    return { category: 'network_failure', detail: msg };
  }
  if (lower.includes('openai') || lower.includes('500') || lower.includes('503') || lower.includes('unavailable') || lower.includes('rate')) {
    return { category: 'openai_error', detail: msg };
  }
  return { category: 'unknown', detail: msg || 'No error detail available.' };
}

export const BETA_MESSAGE = {
  buttonLabel: 'Visual Studio Beta — Coming Soon',
  headline: "Visual Studio is in Beta",
  body: "We\'re polishing image generation for better quality and reliability. Your DreamDNA and business tools are ready to use.",
};
